import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=f4204648&"
import script from "./ArticlesList.vue?vue&type=script&lang=js&"
export * from "./ArticlesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiPagination: require('/app/components/UI/UiPagination.vue').default,SeoPagination: require('/app/components/seo/SeoPagination.vue').default})
